import React from "react";

import classNames from "classnames";
import { CloseButton, Modal } from "react-bootstrap";

import { useUmpireInfoModalContext } from "../contexts/UmpireInfoModal";
import { capitalize } from "../lib/utils";

const UmpireInfoModal = () => {
    const {
        showUmpireInfoModal,
        setShowUmpireInfoModal,
        umpireInfoModalContent: umpire,
    } = useUmpireInfoModalContext();

    return (
        <Modal
            className={classNames("umpireUmpireInfoModal")}
            centered
            show={showUmpireInfoModal}
            onHide={() => setShowUmpireInfoModal(false)}
        >
            <Modal.Header>
                <h4>{umpire && capitalize(umpire.location)} Umpire Info</h4>
                <CloseButton onClick={() => setShowUmpireInfoModal(false)} />
            </Modal.Header>
            <Modal.Body>
                {umpire?.name}
                <br />
                {umpire?.phone}
                <br />
                {umpire?.email && (
                    <a href={`mailto:${umpire.email}`}>{umpire.email}</a>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default UmpireInfoModal;
